import { render, staticRenderFns } from "./DietRestrictions.vue?vue&type=template&id=129a6b92&"
import script from "./DietRestrictions.vue?vue&type=script&lang=js&"
export * from "./DietRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports